import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Wrapper de compatibilidade — implementação real em shared_items/NavbarTop.jsx
// (design-system fase 2/3). Import absoluto (era relativo ../../../) — fase 3 de convenções.
// Settings toggle real (alterna configurações/voltar), igual ao padrão finance —
// era fixo em settingsActive={false} antes (só ida, nunca voltava pelo botão).
// z-20: fica acima do NavbarMiddle (z-10), agora presente na tab Summary — mesmo
// motivo do z-20 em finance/moduleComponents/NavbarTop.jsx.
const NavbarTop = ({ title, onHomeClick, onLogoutClick, handleTabChange, activeTab }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="health"
    onHomeClick={onHomeClick}
    zIndexClass="z-20"
    settingsActive={activeTab === 'settings'}
    onSettingsClick={() => handleTabChange(activeTab === 'settings' ? 'summary' : 'settings')}
  />
);

export default NavbarTop;
